import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ResourceListPage from "@/pages/ResourceListPage";
import CompanyProfile from "@/pages/CompanyProfile";
import EmailRecipients from "@/pages/EmailRecipients";

// Combined Settings & Ingredients (desktop). Same shared backend / master data.
// Company Profile + Ingredient Master + Ingredient Prices as tabs. IDs, price history,
// import/export and duplicate detection preserved (configs keyed by the same paths).
const INGREDIENTS_CFG = {
  label: "Ingredient Master", path: "/ingredients", testId: "ingredients", idKey: "id",
  endpoint: "/ingredients",
  columns: [
    { key: "ingredientId", label: "ID", type: "mono" },
    { key: "name", label: "Name", type: "text" },
    { key: "category", label: "Category", type: "badge" },
    { key: "brand", label: "Brand", type: "text" },
    { key: "unit", label: "Std Unit", type: "text" },
    { key: "packingSize", label: "Pack Size", type: "number" },
    { key: "packingUnit", label: "Pack Unit", type: "text" },
    { key: "rate", label: "Rate", type: "currency" },
    { key: "priceType", label: "Price Type", type: "badge" },
    { key: "active", label: "Active", type: "bool" },
  ],
  searchKeys: ["ingredientId", "name", "brand", "category"],
  filters: [{ key: "category", label: "Category" }, { key: "priceType", label: "Price Type" }],
  exportEndpoint: "/ingredients/export", exportLabel: "Export Master",
};

const PRICES_CFG = {
  label: "Ingredient Prices", path: "/ingredient-prices", testId: "ingredient-prices", idKey: "id",
  endpoint: "/ingredients",
  columns: [
    { key: "ingredientId", label: "ID", type: "mono" },
    { key: "name", label: "Name", type: "text" },
    { key: "priceType", label: "Price Type", type: "badge" },
    { key: "rate", label: "Current Rate", type: "currency" },
    { key: "purchasePrice", label: "Purchase Price", type: "currency" },
    { key: "gstPct", label: "GST %", type: "percent" },
    { key: "lastInvoiceSupplier", label: "Last Supplier", type: "text" },
    { key: "lastInvoiceDate", label: "Last Invoice", type: "text" },
  ],
  searchKeys: ["ingredientId", "name"],
  filters: [{ key: "priceType", label: "Price Type" }],
};

export default function SettingsIngredients() {
  const [tab, setTab] = useState("company");
  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList data-testid="settings-tabs" className="bg-stone-100">
        <TabsTrigger value="company" data-testid="settings-tab-company">Company Profile</TabsTrigger>
        <TabsTrigger value="ingredients" data-testid="settings-tab-ingredients">Ingredients</TabsTrigger>
        <TabsTrigger value="prices" data-testid="settings-tab-prices">Ingredient Prices</TabsTrigger>
        <TabsTrigger value="email" data-testid="settings-tab-email">Reports &amp; Email</TabsTrigger>
      </TabsList>
      <TabsContent value="company"><CompanyProfile /></TabsContent>
      <TabsContent value="ingredients"><ResourceListPage itemOverride={INGREDIENTS_CFG} /></TabsContent>
      <TabsContent value="prices"><ResourceListPage itemOverride={PRICES_CFG} /></TabsContent>
      <TabsContent value="email"><EmailRecipients /></TabsContent>
    </Tabs>
  );
}
